<template>
  <div>
    <forms-list-activity
        ref="orderDetailPM"
        :form-type="FORM_TYPE"
        :context="context"
        :details-config="detailsConfig"
        :details-temporary-list="temporaryList"
        :details-master-form-config="masterFormConfig"
        :details-master-id="masterId"
        :meta-status="metaStatus"
        :has-write-access-to-master="hasWriteAccessToMaster"
        :details-mode="mode"
        :calling-form-config="callingFormConfig"
        :filter="filter"
        :propSelectionSize.sync="selectionSize"
        :propShowMultiSelect.sync="showMultiSelect"
        :editMultiSelectFromTab.sync="editMultiSelectFromTab"
        @search="searchExecute"
        @add="addNewOrderDetails"
        :custom-add="true"
        @selected="getSelectedEntity"
        @loading-data="loadingData"
        @start-loading-data="startLoadingData"
        @markReadyToShow="markReadyToShow"
    >
    </forms-list-activity>
    <b-container v-if="readyToShow">
      <b-row class="text-center m-3">
        <b-col class="pr-5" cols="5">
          {{ $tr('orderDetailsList.valueOfOrder', 'Value of the Order in the Purchase Price:') }}
          {{ sumOfValueOfOrderInThePurchasePrice }} {{ currencyName }}
        </b-col>
        <b-col class="pr-5">
          {{ $tr('orderedQuantity:', 'Ordered Quantity:') }} {{ sumOfOrderedQuantity }}
        </b-col>
        <b-col class="pr-5">
          {{ $tr('cartons', 'Cartons:') }} {{ sumOfCartons }}
        </b-col>
        <b-col class="pr-5">
          CBM: {{ sumOfCBM }}
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import FormsListActivity from "@/activity/templates/layouts/forms/FormsListActivity";
import OrderDetails from "@/server/com/silkplm/model/plm/OrderDetails";
import Activity from "@/activity/Activity";
import FormsActions, {DELETE_RESTRICTED} from "@/components/forms/FormsActions";
import BudgetingPlannerPM from "@/server/com/silkplm/model/plm/BudgetingPlannerPM";
import DialogManager from "@/utils/DialogManager";
import FormsLoader from "@/components/forms/FormsLoader";
import Rpc from "@/Rpc";
import TemporaryList from "@/components/forms/TemporaryList";
import PlanningProduct from "@/server/com/silkplm/model/plm/PlanningProduct";
import Order from "@/server/com/silkplm/model/plm/Order";
import EntitiesList from "@/components/forms/EntitiesList.vue";
import ColorVersionBindingPlanning from "@/server/com/silkplm/model/plm/ColorVersionBindingPlanning";
import {
  checkIfEnabledByOrganizationFormsSettingsForForm,
  checkIfEnabledByOrganizationFormsSettingsForFormField,
  findFieldValueFromCompanyCompanyConfigurationForm
} from "@/components/forms/customizations/plm/EntityEditFormService";
import ColorVersion from "@/server/com/silkplm/model/plm/ColorVersion";
import ProductInSeason from "@/server/com/silkplm/model/plm/ProductInSeason";
import ComponentIndex from "@/server/com/silkplm/model/plm/dictionaries/ComponentIndex";
import SelectFilterSpec from "@/server/com/silkplm/engine/forms/schema/definition/filters/SelectFilterSpec";
import FeatureFlag from "@/server/com/silkplm/rpc/FeatureFlag";


const FORM_TYPE = OrderDetails;
export default {
  name: "OrderDetailsList",
  components: {EntitiesList, FormsListActivity},

  // commit
  async mounted() {
    // this.$refs.orderDetailPM.$on("filter-products-other-users",  () => {console.log("works ")}); // TODO KIEDYŚ, CHWILOWO EVENT BUSEM ZROBIONE
    this.$onUpdate(Order, async (changeEvent) => {
      if (changeEvent.id === this.orderInstance.id) {
        this.orderInstance = changeEvent.instance;
      }
    });
    let companyConfiguration = await Rpc.plm.services.CompanyConfigurationService.findFunctionalFlagsForOrganization().lock();
    this.budgetPlannerPath = companyConfiguration.budgetPlanner;

    this.entititesList = this.$refs.orderDetailPM.$refs.entititesList;
    if (this.masterId) {
      this.orderInstance = await Rpc.Forms.getEntity(this.masterFormConfig.formClassLong, this.masterId).lock();
    }
    this.$onEvent("filter-products-other-users", this.filterOtherProducts);
  },

  methods: {
    ...Activity.methods,

    getTitle() {
      return this.$refs.orderDetailPM?.getTitle() ?? "Order details";
    },

    async formCreated(form) {
      this.form = form;
    },

    startLoadingData() {
      console.log("Start loading data");
      this.sumOfValueOfOrderInThePurchasePrice = null;
      this.currencyName = null;
      this.sumOfOrderedQuantity = null;
      this.sumOfCartons = null;
      this.sumOfCBM = null;
    },

    async loadingData(streamingEngine) {
      await this.calcValues(streamingEngine);
    },

    async filterOtherProducts() {
      this.filteredOtherProducts = !this.filteredOtherProducts;
      let seasonId = this.orderInstance.seasonId;
      let supplierId = this.orderInstance.supplierId;
      let merchant = this.orderInstance.merchant;
      let PM = this.orderInstance.PM;
      let entitiesList = null;
      if (this.budgetPlannerPath) {
        entitiesList = this.simpleBudgetingPlannerPMViewActivity?.$refs?.formList?.$refs?.entititesList;
      } else {
        entitiesList = this.colorVersionListActivity?.$refs?.formList?.$refs?.entititesList;
      }
      if (!entitiesList) {
        return;
      }
      let grid = entitiesList.$refs.grid;
      grid.selectMultiselectNone();
      if (!this.baseProductToOrderList) {
        this.baseProductToOrderList = entitiesList.lists;
      }
      if (!this.customProductList) {
        if (this.budgetPlannerPath) {
          this.customProductList = await Rpc.plm.services.BudgetingPlannerService.getFilteredBudgetingPlannerPmRecordsForEveryUser(seasonId, supplierId, merchant, PM);
        } else {
          this.customProductList = await Rpc.plm.services.OrderDetailsService.getAllColorVersionBindingPlanningConfirmedForEveryUser(supplierId, seasonId, merchant, PM);
        }
      }
      if (!this.toggledButton) {
        entitiesList.setCustomData(this.customProductList);
      } else {
        entitiesList.lists = this.baseProductToOrderList;
        entitiesList.list = this.baseProductToOrderList;
      }
      this.toggledButton = !this.toggledButton;
    },

    async calcValues(streamingEngine) {
      let streamSelection = streamingEngine.getStreamSelection();
      let result = await Rpc.plm.services.OrderDetailsService.computedSummaryValuesToOrderDetailsList(streamSelection);
      this.sumOfOrderedQuantity = result["sumOfOrderedQuantity"];
      this.sumOfCBM = result["sumOfCBM"];
      this.sumOfCartons = result["sumOfCartons"];
      this.sumOfValueOfOrderInThePurchasePrice = result["sumOfValueOfOrderInThePurchasePrice"];
      this.currencyName = result["currencyName"];
      this.readyToShow = true;
    },

    markReadyToShow() {
      this.$emit("markReadyToShow")
    },


    async searchExecute() {
      let streamingEngine = this.$refs.orderDetailPM.$refs.entititesList.streamingEngine;
      await this.calcValues(streamingEngine);
    },

    async addNewOrderDetails() {
      this.toggledButton = false;
      if (!this.orderInstance) {
        return;
      }
      if (this.orderInstance.orderForRawMaterials) {
        await this.addNewOrderDetailFromComponentIndexView();
        return;
      }
      if (this.budgetPlannerPath) {
        await this.addNewOrderDetailsFromBudgetingPlannerPMView();
      } else {
        await this.addNewOrderDetailsFromColorVersionsView();
      }
    },

    async addNewOrderDetailFromComponentIndexView() {
      let supplierId = this.orderInstance.supplierId;
      let filter = new SelectFilterSpec().withIdValues([supplierId]);
      let supplierCompanyConfigurationFormField = await Rpc.plm.services.CompanyConfigurationService.findSettingsForFormField(this.formConfigComponentIndex.formId, "supplierId");
      let filterSpecs = {
        fieldName: "supplierId",
        fieldLabel: supplierCompanyConfigurationFormField.fieldLabel,
        filterSpec: filter
      };
      let rangeFilters = {customFilter: [filterSpecs]};
      let props = {filter: rangeFilters};
      let result = await (await FormsActions.showMultiSelectList(ComponentIndex, props)).getResult();
      let records = [];
      if (result) {
        if (result.materialize) {
          await result.materialize();
        }
        for (let item of result) {
          records.push(item);
        }
      }
      let orderStatus = await this.orderInstance.getOrderStatusEntity();
      let inProductionStatus = null;
      if (orderStatus && orderStatus.name?.toUpperCase() === "CONFIRMED") {
        inProductionStatus = await Rpc.plm.services.OrderDetailsService.findInProductionShipmentSampleStatus().lock();
      }

      let isTrancheIntegrated = false;
      if (this.orderInstance.EXWPI) {
        isTrancheIntegrated = await Rpc.plm.services.TrancheService.checkIfTrancheIsIntegrated(this.orderInstance).lock();
      }
      if (records?.length === 1) {
        let componentIndex = records[0];
        await this.addOneOrderDetailsWithComponentIndex(orderStatus, inProductionStatus, isTrancheIntegrated, componentIndex);
      } else if (records?.length > 1) {
        let orderDetailsList = [];
        for (let componentIndex of records) {
          let orderDetails = await this.addMultiOrderDetailsWithComponentIndex(orderStatus, inProductionStatus, isTrancheIntegrated, componentIndex);
          orderDetailsList.push(orderDetails);
        }
        await Rpc.plm.services.OrderDetailsService.addOrderDetailsAfterSelectOnPlanners(orderDetailsList).lock();
      }
    },

    async addNewOrderDetailsFromColorVersionsView() {
      let seasonId = this.orderInstance.seasonId;
      let supplierId = this.orderInstance.supplierId;
      let merchant = this.orderInstance.merchant;
      let PM = this.orderInstance.PM;
      let colorVersionBindingPlanningList = await Rpc.plm.services.OrderDetailsService.getAllColorVersionsBindingsPlaningWithConfirmedStatus(
          supplierId, seasonId, merchant, PM).lock();
      let colorVersionFormEnabled = checkIfEnabledByOrganizationFormsSettingsForForm(this.formConfigForColorVersion.formId);
      let view = FormsLoader.formByType(ColorVersionBindingPlanning);
      let viewFields = view.fields;
      viewFields.forEach((field => {
        if (field.fieldName === "colorVersionIdColor") {
          this.setVisibilityOfField(field, colorVersionFormEnabled);
        }
      }));
      this.colorVersionListActivity = await FormsActions.showMultiSelectListFromIds(view, {}, []);
      let entitiesList = null;
      entitiesList = this.colorVersionListActivity?.$refs?.formList?.$refs?.entititesList;
      entitiesList.setCustomData(colorVersionBindingPlanningList);
      let records = await this.colorVersionListActivity.getResult();
      let orderStatus = await this.orderInstance.getOrderStatusEntity();
      let inProductionStatus = null;
      if (orderStatus && orderStatus.name?.toUpperCase() === "CONFIRMED") {
        inProductionStatus = await Rpc.plm.services.OrderDetailsService.findInProductionShipmentSampleStatus().lock();
      }

      let isTrancheIntegrated = false;
      if (this.orderInstance.EXWPI) {
        isTrancheIntegrated = await Rpc.plm.services.TrancheService.checkIfTrancheIsIntegrated(this.orderInstance).lock();
      }
      if (records?.length === 1) {
        let colorVersionBindingPlanning = records[0];
        let planningProduct = await colorVersionBindingPlanning.getPlanningProductIdEntity();
        let productInSeason = await planningProduct.getProductSeasonIdEntity();
        let product = await productInSeason.getProductIdEntity();
        await this.addOneOrderDetails(productInSeason, product, planningProduct, null, orderStatus,
            inProductionStatus, isTrancheIntegrated, false, colorVersionBindingPlanning.colorVersionId);
      } else if (records?.length > 1) {
        let orderDetailsList = [];
        let skuInColorVersion = this.checkIfSkuActiveOnColorVersion();
        let skuInProductInSeason = this.checkIfSkuActiveOnProductInSeason();
        for (let colorVersionBindingPlanning of records) {
          let planningProduct = await colorVersionBindingPlanning.getPlanningProductIdEntity();
          let productInSeason = await planningProduct.getProductSeasonIdEntity();
          let product = await productInSeason.getProductIdEntity();
          let orderDetails = await this.addMultiOrderDetails(productInSeason, product, planningProduct, null,
              orderStatus, inProductionStatus, isTrancheIntegrated, false,
              colorVersionBindingPlanning.colorVersionId, skuInColorVersion, skuInProductInSeason);
          orderDetailsList.push(orderDetails);
        }
        await Rpc.plm.services.OrderDetailsService.addOrderDetailsAfterSelectOnPlanners(orderDetailsList).lock();
      }
    },
    setVisibilityOfField(field, active) {
      field.formDisabled = !active;
      field.gridColDisabled = !active;
      field.gridColVisible = active;
    },

    async addNewOrderDetailsFromBudgetingPlannerPMView() {
      let seasonId = this.orderInstance.seasonId;
      let supplierId = this.orderInstance.supplierId;
      let merchant = this.orderInstance.merchant;
      let PM = this.orderInstance.PM;
      let filteredRecords = await Rpc.plm.services.BudgetingPlannerService.getFilteredBudgetingPlannerPmRecords(seasonId, supplierId, merchant, PM).lock();
      let view = FormsLoader.viewByTypeAndName(BudgetingPlannerPM, "SimpleBudgetingPlannerPM");
      let viewFields = view.fields;
      for (let field of viewFields) {
        if (field.fieldName === "colorVersionIdColor") {
          let formConfigBP = FormsLoader.detectFormConfig(BudgetingPlannerPM.getRemoteClass());
          let colorVersionNumberFormFieldConfig = await Rpc.plm.services.CompanyConfigurationService.findSettingsForFormField(formConfigBP.formId, "colorVersionIdColor");
          if (!colorVersionNumberFormFieldConfig.active) {
            this.setVisibilityOfField(field, colorVersionNumberFormFieldConfig.active);
          }
        }
      }
      this.simpleBudgetingPlannerPMViewActivity = await FormsActions.showMultiSelectListFromIds(view, []);
      let entitiesList = null;
      entitiesList = this.simpleBudgetingPlannerPMViewActivity?.$refs?.formList?.$refs?.entititesList;
      entitiesList.setCustomData(filteredRecords);
      let records = await this.simpleBudgetingPlannerPMViewActivity.getResult();
      let orderStatus = await this.orderInstance.getOrderStatusEntity();
      let inProductionStatus = null;
      if (orderStatus && orderStatus.name?.toUpperCase() === "CONFIRMED") {
        inProductionStatus = await Rpc.plm.services.OrderDetailsService.findInProductionShipmentSampleStatus();
      }

      let isTrancheIntegrated = false;
      if (this.orderInstance.EXWPI) {
        isTrancheIntegrated = await Rpc.plm.services.TrancheService.checkIfTrancheIsIntegrated(this.orderInstance);
      }
      if (records?.length === 1) {
        let record = records[0];
        let productInSeason = await record.getProductIdEntity();
        let product = await productInSeason.getProductIdEntity();
        let planning = await record.getPlanningIdEntity();
        await this.addOneOrderDetails(productInSeason, product, planning, record, orderStatus, inProductionStatus,
            isTrancheIntegrated, SessionManager.hasFlag(FeatureFlag.SEPARATE_PRODUCT), record.colorVersionId);
      } else if (records?.length > 1) {
        let orderDetailsList = [];
        let skuInColorVersion = this.checkIfSkuActiveOnColorVersion();
        let skuInProductInSeason = this.checkIfSkuActiveOnProductInSeason();
        for (let record of records) {
          let productInSeason = await record.getProductIdEntity();
          let product = await productInSeason.getProductIdEntity();
          let planning = await record.getPlanningIdEntity();
          let orderDetails = await this.addMultiOrderDetails(productInSeason, product, planning, record, orderStatus,
              inProductionStatus, isTrancheIntegrated, SessionManager.hasFlag(FeatureFlag.SEPARATE_PRODUCT), record.colorVersionId, skuInColorVersion, skuInProductInSeason);
          orderDetailsList.push(orderDetails);
        }
        await Rpc.plm.services.OrderDetailsService.addOrderDetailsAfterSelectOnPlanners(orderDetailsList).lock();
      }
    },

    checkIfSkuActiveOnColorVersion() {
      let fieldConfigSKUNumberForColorVersion = this.formConfigForColorVersion.fields.filter(field => field.fieldName === 'SKUNumber')[0];
      let activeFieldInConfiguration = checkIfEnabledByOrganizationFormsSettingsForFormField(this.formConfigForColorVersion, fieldConfigSKUNumberForColorVersion);
      if (activeFieldInConfiguration) {
        return true;
      }
      return false;
    },

    checkIfSkuActiveOnProductInSeason() {
      let fieldConfigSKUNumberForProductInSeason = this.formConfigForProductInSeason.fields.filter(field => field.fieldName === 'SKUNumber')[0];
      let activeFieldInConfiguration = checkIfEnabledByOrganizationFormsSettingsForFormField(this.formConfigForProductInSeason, fieldConfigSKUNumberForProductInSeason);
      if (activeFieldInConfiguration) {
        return true;
      }
      return false;
    },

    async addOneOrderDetailsWithComponentIndex(orderStatus, inProductionStatus, isTrancheIntegrated, componentIndex) {
      let formConfig = FormsLoader.detectFormConfig(FORM_TYPE);
      let context = {
        ...this.context,
        presetFields: [
          {fieldName: "orderId", value: this.orderInstance.id},
          {fieldName: "price", value: componentIndex.pricePerUnit},
          {fieldName: "unitId", value: componentIndex.unitId},
          {fieldName: "colorId", value: componentIndex.colorId},
          {fieldName: "supplierProductId", value: componentIndex.supplierProductId},
          {fieldName: "name", value: componentIndex.name},
          {fieldName: "gallery", value: componentIndex.gallery},
          {fieldName: "category", value: componentIndex.category},
          {fieldName: "componentIndexId", value: componentIndex.id},
          {fieldName: "rawMaterialsPath", value: true},
          {fieldName: "merchant", value: this.orderInstance.merchant},
          {fieldName: "PM", value: this.orderInstance.PM},
          {
            fieldName: "realEXW",
            value: ((orderStatus?.name?.toUpperCase() === "CONFIRMED" || orderStatus?.name?.toUpperCase() === "CLOSED") &&
                this.orderInstance.EXWPI && !isTrancheIntegrated) ? this.orderInstance.EXWPI : null
          },
          {
            fieldName: "EXWPI",
            value: ((orderStatus?.name?.toUpperCase() === "CONFIRMED" || orderStatus?.name?.toUpperCase() === "CLOSED") &&
                this.orderInstance.EXWPI) ? this.orderInstance.EXWPI : null
          },
          {fieldName: "statusShipment", value: inProductionStatus?.id},
        ]
      }
      await FormsActions.create(formConfig, {
            context: context,
            orderId: this.orderInstance.id,
            orderClass: this.masterFormConfig.formClassLong
          }
      );
    },

    async addOneOrderDetails(productInSeason, product, planning, budgetingPlannerPM, orderStatus, inProductionStatus,
                             isTrancheIntegrated, insertFromBudget, colorVersionId) {
      let formConfig = FormsLoader.detectFormConfig(FORM_TYPE);
      let colorVersion = null;
      if (insertFromBudget) {
        colorVersion = await budgetingPlannerPM.getColorVersionIdEntity();
      } else {
        colorVersion = await Rpc.Forms.getEntity(ColorVersion.getRemoteClass(), colorVersionId);
      }
      let SKUNumber = "";
      if (this.checkIfSkuActiveOnColorVersion()) {
        SKUNumber = colorVersion.SKUNumber;
      } else if (this.checkIfSkuActiveOnProductInSeason()) {
        SKUNumber = productInSeason.SKUNumber;
      }
      let eanToInsert = null;
      if (product.EANList?.length === 1) {
        eanToInsert = product.EANList[0].EAN;
      }
      let orderedQuantity = null;
      if (!insertFromBudget) {
        orderedQuantity = colorVersion.totalQuantityToOrder;
      }
      let otherCostInOffer = await Rpc.plm.services.PlanningProductService.findOtherCostInOfferForPlanningProduct(planning.id).lock();
      let duty = otherCostInOffer.dutyCosts[0].duty;
      // real exw
      let context = {
        ...this.context,
        presetFields: [
          {fieldName: "budgetingPlannerPMId", value: budgetingPlannerPM?.id},
          {fieldName: "planningId", value: planning.id},
          {fieldName: "orderId", value: this.orderInstance.id},
          {fieldName: "productInSeasonId", value: productInSeason.id},
          {fieldName: "productId", value: productInSeason.productId},
          {fieldName: "subSeasonId", value: productInSeason.subSeasonId},
          {fieldName: "PM", value: product.PM},
          {fieldName: "merchant", value: this.assignMerchantToOrderDetails(product)},
          {fieldName: "price", value: budgetingPlannerPM ? budgetingPlannerPM.price : planning.price},
          {fieldName: "WMS", value: budgetingPlannerPM?.WMS},
          {fieldName: "category", value: budgetingPlannerPM ? budgetingPlannerPM.categoryId : product.category},
          {fieldName: "port", value: planning.portOfShipment},
          {fieldName: "country", value: planning.originCountry},
          {fieldName: "defaultEAN", value: eanToInsert},
          {fieldName: "duty", value: duty},
          {fieldName: "confirmedETD", value: planning.confirmedETD},
          {fieldName: "unitId", value: product.unit},
          {fieldName: "colorId", value: colorVersion.color},
          {fieldName: "supplierProductId", value: product.supplierProductId},
          {fieldName: "name", value: product.name},
          {fieldName: "gallery", value: product.gallery},
          {
            fieldName: "realEXW",
            value: ((orderStatus?.name?.toUpperCase() === "CONFIRMED" || orderStatus?.name?.toUpperCase() === "CLOSED") &&
                this.orderInstance.EXWPI && !isTrancheIntegrated) ? this.orderInstance.EXWPI : null
          },
          {
            fieldName: "EXWPI",
            value: ((orderStatus?.name?.toUpperCase() === "CONFIRMED" || orderStatus?.name?.toUpperCase() === "CLOSED") &&
                this.orderInstance.EXWPI) ? this.orderInstance.EXWPI : null
          },
          {fieldName: "statusShipment", value: inProductionStatus?.id},
          {fieldName: "colorVersionId", value: colorVersion.id},
          {fieldName: "orderedQuantity", value: orderedQuantity},
          {fieldName: "SKUNumber", value: SKUNumber},
        ]
      }
      await FormsActions.create(formConfig, {
            context: context,
            planning: planning,
            budgetingPlannerPM: budgetingPlannerPM,
            orderId: this.orderInstance.id,
            orderClass: this.masterFormConfig.formClassLong
          }
      );
    },
    async addMultiOrderDetailsWithComponentIndex(orderStatus, inProductionStatus, isTrancheIntegrated, componentIndex) {
      let orderDetailsInstance = new OrderDetails();
      orderDetailsInstance.merchant = this.orderInstance.merchant
      orderDetailsInstance.PM = this.orderInstance.PM;
      orderDetailsInstance.orderId = this.orderInstance.id;
      orderDetailsInstance.price = componentIndex.pricePerUnit;
      orderDetailsInstance.category = componentIndex.category;
      orderDetailsInstance.componentIndexId = componentIndex.id;
      orderDetailsInstance.unitId = componentIndex.unitId;
      orderDetailsInstance.colorId = componentIndex.colorId;
      orderDetailsInstance.supplierProductId = componentIndex.supplierProductId;
      orderDetailsInstance.name = componentIndex.name;
      orderDetailsInstance.gallery = componentIndex.gallery;
      orderDetailsInstance.rawMaterialsPath = true;
      if ((orderStatus?.name?.toUpperCase() === "CONFIRMED" || orderStatus?.name?.toUpperCase() === "CLOSED") && this.orderInstance.EXWPI) {
        orderDetailsInstance.EXWPI = this.orderInstance.EXWPI;
        if (!isTrancheIntegrated) {
          orderDetailsInstance.realEXW = this.orderInstance.EXWPI;
        }
      }
      orderDetailsInstance.statusShipment = inProductionStatus?.id;
      return orderDetailsInstance;
    },
    async addMultiOrderDetails(productInSeason, product, planning, budgetingPlannerPM, orderStatus, inProductionStatus,
                               isTrancheIntegrated, insertFromBudget, colorVersionId, skuInColorVersion, skuInProductInSeason) {
      let orderDetailsInstance = new OrderDetails();
      let eanToInsert = null;
      let colorVersion = null;
      if (insertFromBudget) {
        colorVersion = await budgetingPlannerPM.getColorVersionIdEntity();
      } else {
        colorVersion = await Rpc.Forms.getEntity(ColorVersion.getRemoteClass(), colorVersionId);
        orderDetailsInstance.orderedQuantity = colorVersion.totalQuantityToOrder;
      }
      orderDetailsInstance.colorVersionId = colorVersion.id;
      if (skuInColorVersion) {
        orderDetailsInstance.SKUNumber = colorVersion.SKUNumber;
      } else if (skuInProductInSeason) {
        orderDetailsInstance.SKUNumber = productInSeason.SKUNumber;
      }
      if (product.EANList?.length === 1) {
        eanToInsert = product.EANList[0].EAN;
      }
      orderDetailsInstance.budgetingPlannerPMId = budgetingPlannerPM?.id;
      orderDetailsInstance.planningId = planning.id;
      orderDetailsInstance.orderId = this.orderInstance.id;
      orderDetailsInstance.productInSeasonId = productInSeason.id;
      orderDetailsInstance.subSeasonId = productInSeason.subSeasonId;
      orderDetailsInstance.PM = product.PM;
      orderDetailsInstance.merchant = this.assignMerchantToOrderDetails(product)
      orderDetailsInstance.price = budgetingPlannerPM ? budgetingPlannerPM.price : planning.price
      orderDetailsInstance.category = budgetingPlannerPM ? budgetingPlannerPM.categoryId : product.category
      orderDetailsInstance.port = planning.portOfShipment;
      orderDetailsInstance.country = planning.originCountry;
      orderDetailsInstance.confirmedETD = planning.confirmedETD;
      orderDetailsInstance.defaultEAN = eanToInsert;
      orderDetailsInstance.unitId = product.unit;
      orderDetailsInstance.colorId = colorVersion.color;
      orderDetailsInstance.supplierProductId = product.supplierProductId;
      orderDetailsInstance.name = product.name;
      orderDetailsInstance.gallery = product.gallery;
      if ((orderStatus?.name?.toUpperCase() === "CONFIRMED" || orderStatus?.name?.toUpperCase() === "CLOSED") && this.orderInstance.EXWPI) {
        orderDetailsInstance.EXWPI = this.orderInstance.EXWPI;
        if (!isTrancheIntegrated) {
          orderDetailsInstance.realEXW = this.orderInstance.EXWPI;
        }
      }
      orderDetailsInstance.statusShipment = inProductionStatus?.id;

      let otherCostInOffer = await Rpc.plm.services.PlanningProductService.findOtherCostInOfferForPlanningProduct(planning.id).lock();
      orderDetailsInstance.duty = otherCostInOffer.dutyCosts[0].duty;
      return orderDetailsInstance;
    },

    assignMerchantToOrderDetails(product) {
      if (!this.filteredOtherProducts) {
        return this.orderInstance.merchant;
      }
      if (!product.merchants || !product.merchants.length) {
        return null;
      }
      return product.merchants[0].merchantId;
    },

    async getSelectedEntity(selectionProxy) {
      this.selectedOrderDetailsList = [];
      if (selectionProxy?.materialize) {
        for (let item of selectionProxy.knownSelected) {
          if (item[1]) {
            this.selectedOrderDetailsList.push(item[1]);
          }
        }
      } else if (selectionProxy?.length) {
        for (let el of selectionProxy) {
          this.selectedOrderDetailsList.push(el);
        }
      }
    },
  },

  props: {
    hasWriteAccessToMaster: {default: false},
    context: {default: null},
    detailsMode: {type: String, default: ""},
    detailsTemporaryList: {type: TemporaryList, default: null},
    detailsConfig: {default: null},
    masterId: {default: null},
    mode: {default: null},
    temporaryList: {default: null},
    masterFormConfig: {default: null},
    metaStatus: {default: null},
    callingFormConfig: {default: null},
    filter: {default: null},
    selectionSize: 0,
    showMultiSelect: false,
  },

  watch: {
    selectionSize: function (val) {
      this.$emit("update:selectionSize", this.selectionSize);
    },
    showMultiSelect: function (val) {
      this.$emit("update:showMultiSelect", this.showMultiSelect);
    },
    editMultiSelectFromTab: function (val) {
      this.$emit("update:editMultiSelectFromTab", val);
    },
  },

  data: function () {
    const that = this;
    return {
      formConfigForColorVersion: FormsLoader.detectFormConfig(ColorVersion.getRemoteClass()),
      formConfigForProductInSeason: FormsLoader.detectFormConfig(ProductInSeason.getRemoteClass()),
      formConfigComponentIndex: FormsLoader.detectFormConfig(ComponentIndex.getRemoteClass()),
      FORM_TYPE,
      selectedOrderDetailsList: null,
      filteredOtherProducts: false,
      orderInstance: null,
      formConfig: FormsLoader.detectFormConfig(FORM_TYPE),
      // dataLoader: function (...args) {
      //   return that.loadData(...args);
      // },
      entititesList: null,
      sumOfOrderedQuantity: null,
      sumOfCBM: null,
      sumOfCartons: null,
      sumOfValueOfOrderInThePurchasePrice: null,
      currencyName: null,
      budgetPlannerPath: null,
      baseProductToOrderList: null,
      customProductList: null,
      toggledButton: false,
      readyToShow: false,
      editMultiSelectFromTab: {default: false}

    }
  }
}
</script>